import React from 'react';
import { SignUpForm } from '../Form/SignUpForm';
import { UserFlowTypes } from '../..';
import { SectionCardTitle } from '../../../../components/textVariations';

export const CreateAccount = ({
  emailId,
  CreatePassword,
}: UserFlowTypes.TCreateAccount) => {
  return (
    <div className="ParentContainer">
      <div className="childPasswordContainer">
        <div>
          <div className="titleSignUpContainer">
            <SectionCardTitle>Create Account</SectionCardTitle>
          </div>
          <div>
            <SignUpForm emailId={emailId} CreatePassword={CreatePassword} />
          </div>
        </div>
      </div>
    </div>
  );
};
